import { z } from 'zod';
export const credentialKindSchema = z.enum(['ssh_password', 'ssh_key', 'snmp_v2c', 'snmp_v3', 'api_token', 'basic']);
/** Secret payload per kind. Validated on create/update, encrypted as one JSON blob, never returned. */
export const credentialSecretSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('ssh_password'), password: z.string().min(1) }),
    z.object({ kind: z.literal('ssh_key'), privateKey: z.string().min(1), passphrase: z.string().optional() }),
    z.object({ kind: z.literal('snmp_v2c'), community: z.string().min(1) }),
    z.object({
        kind: z.literal('snmp_v3'),
        securityLevel: z.enum(['noAuthNoPriv', 'authNoPriv', 'authPriv']).default('authPriv'),
        authProtocol: z.enum(['sha', 'sha256', 'sha512', 'md5']).default('sha'),
        authKey: z.string().optional(),
        privProtocol: z.enum(['aes', 'aes256b', 'aes256r', 'des']).default('aes'),
        privKey: z.string().optional(),
    }),
    z.object({ kind: z.literal('api_token'), token: z.string().min(1), header: z.string().default('authorization'), prefix: z.string().default('Bearer ') }),
    z.object({ kind: z.literal('basic'), password: z.string().min(1) }),
]);
export const credentialCreateSchema = z.object({
    label: z.string().min(1).max(80),
    kind: credentialKindSchema,
    targetGlob: z.string().min(1).max(500),
    minRole: z.enum(['ADMIN', 'ENGINEER', 'VIEWER']).default('ENGINEER'),
    username: z.string().max(200).optional(),
    notes: z.string().max(2000).optional(),
    secret: credentialSecretSchema,
});
export const credentialUpdateSchema = z.object({
    label: z.string().min(1).max(80).optional(),
    targetGlob: z.string().min(1).max(500).optional(),
    minRole: z.enum(['ADMIN', 'ENGINEER', 'VIEWER']).optional(),
    username: z.string().max(200).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    /** Omit to keep the stored secret. */
    secret: credentialSecretSchema.optional(),
});
export const auditQuerySchema = z.object({
    user: z.string().optional(),
    action: z.string().optional(),
    actor: z.enum(['user', 'agent', 'system']).optional(),
    target: z.string().optional(),
    q: z.string().max(200).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
    before: z.string().optional(),
});
//# sourceMappingURL=credential.js.map